import { InvoiceDocument, InvoiceDocumentSearch, SearchTypeEnum } from '@/models/gen/graphql';

import { SearchInvoiceDocumentDocument } from '@/api/queries';
import graphApi from '@/api';

const [, refetchSearchInvoiceDocument] = graphApi(SearchInvoiceDocumentDocument);

const searchInvoiceDocument = async (
  search?: InvoiceDocumentSearch,
  first: number = 1000,
  after: string | null = null
): Promise<InvoiceDocument[]> => {
  const res = await refetchSearchInvoiceDocument({
    input: {
      query: [search],
      first,
      after,
    },
  });

  return res?.searchInvoiceDocument?.invoiceDocumentConnection?.edges?.map?.((edge) => edge.node) as InvoiceDocument[];
};

export const searchInvoiceDocumentByInvoiceId = async (
  invoiceId: string | number | (string | number)[],
  first?: number,
  after?: string | null
): Promise<InvoiceDocument[]> =>
  await searchInvoiceDocument(
    {
      invoiceId: [
        {
          values: Array.isArray(invoiceId) ? invoiceId.map(Number) : [Number(invoiceId)],
          type: SearchTypeEnum.Or,
          sort: null,
        },
      ],
    },
    first,
    after
  );

export const searchInvoiceDocumentByDocumentId = async (
  documentId: string | number | (string | number)[],
  first?: number,
  after?: string | null
): Promise<InvoiceDocument> => {
  const [doc] = await searchInvoiceDocument(
    {
      genDocumentId: [
        {
          values: Array.isArray(documentId) ? documentId.map(String) : [String(documentId)],
          type: SearchTypeEnum.Or,
          sort: null,
        },
      ],
    },
    first,
    after
  );
  return doc;
};

export default searchInvoiceDocument;
